import { useContext } from 'react';

import { getGsdUnit, GsdUnit } from '../../utils/proj4/units';
import { ProjectSpatialReferenceContext } from '../state/project-reference-state';

/**
 * Returns the unit a GSD is entered in for the project's coordinate system,
 * meters when rendered outside a project.
 */
export const useGsdUnit = (): GsdUnit => {
  // The context has no default value, so it is undefined outside ProjectReferenceProvider.
  return getGsdUnit(useContext(ProjectSpatialReferenceContext)?.linearUnit ?? 'm');
};
